module.exports = __webpack_public_path__ + "static/gonczarowski-hex-0864866f4394764014d539a4d352af93.png";